import { Helmet } from "react-helmet";

// Open Graph + Twitter Card метатеги. Отдельного OG-изображения на сайте нет,
// поэтому по умолчанию используем apple-touch-icon (card = summary).
export default function SocialMeta({ title, description, image, type = "website" }) {
  const origin =
    typeof window !== "undefined" ? window.location.origin : "https://boostclick.ru";
  const url =
    typeof window !== "undefined"
      ? window.location.origin + window.location.pathname
      : "https://boostclick.ru";
  const img = image || origin + "/apple-touch-icon.png";

  return (
    <Helmet>
      <meta property="og:site_name" content="Boostclick" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
